export default function DadosUsuarioCard({ perfil }) {
    const perfis = perfil?.perfis?.length ? perfil.perfis.join(", ") : "-";
    const grupos = perfil?.grupos?.length ? perfil.grupos.join(", ") : "-";

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 pt-2">
            <Campo label="Nome" value={perfil?.nome} />
            <Campo label="Usuário" value={perfil?.nomeUsuario} />
            <Campo label="E-mail" value={perfil?.email} />
            <Campo label="Cargo" value={perfil?.cargo} />
            <Campo label="Grupo(s)" value={grupos} />
            <Campo label="Perfil" value={perfis} />
        </div>
    );
}

function Campo({ label, value }) {
    return (
        <div>
            <div className="text-xs text-muted-foreground">{label}</div>
            <div className="font-medium text-foreground">{value || "-"}</div>
        </div>
    );
}
